import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Snackbar,
  Alert,
  Grid,
  Paper,
  Box,
} from '@mui/material';
import { getCompromisoPorNormativa } from '../../componentes/http/actions/CompromisoAction';

const DetalleCompromiso = () => {
  const { idNormativa } = useParams();
  const [compromisos, setCompromisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  /*
  // Función para determinar si se debe mostrar la columna de clientes
  const shouldShowClientesColumn = useCallback(() => {
    if (compromisos.length === 0) return false;
    
    // Obtener todos los clientes únicos de todos los compromisos
    const allClientes = new Set();
    compromisos.forEach(compromiso => {
      compromiso.clientes.forEach(cliente => {
        allClientes.add(cliente.id); // Usar ID para evitar duplicados por nombre similar
      });
    });
    
    // Mostrar la columna solo si hay más de un cliente único
    return allClientes.size > 1;
  }, [compromisos]);
*/
  const fetchCompromisos = useCallback(() => {
    setIsLoading(true);
    
    // El token puede ser null para acceso público
    const token = localStorage.getItem("token");
    
    getCompromisoPorNormativa(token, idNormativa)
      .then((response) => {
        setCompromisos(response);
      })
      .catch((error) => {
        console.error("Error fetching compromisos:", error);
        setSnackbar({
          open: true,
          message: "Error al cargar los compromisos",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  }, [idNormativa]);

  useEffect(() => {
    if (idNormativa) {
      fetchCompromisos(); // Solo llamar a fetchCompromisos
    }
  }, [fetchCompromisos, idNormativa]);

  // Obtener el nombre de la normativa del primer compromiso
  const nombreNormativa = compromisos.length > 0 ? compromisos[0].nombreNormativa : null;

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid item>
          <Typography variant="h4">
            Compromisos
          </Typography>
          {nombreNormativa && (
            <Typography variant="h6" sx={{ mt: 1 }}>
              Normativa: {nombreNormativa}
            </Typography>
            )}
        </Grid>

        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : compromisos.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Descripción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {compromisos.map((compromiso) => (
                <TableRow key={compromiso.id}>
                  <TableCell>{compromiso.descripcion}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No hay compromisos para esta normativa.</Typography>
        )}

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Paper>
    </Grid>
  );
};

export default DetalleCompromiso;